import { render } from "./WorkCardsPageWorks.vue?vue&type=template&id=41798905&scoped=true"
import script from "./WorkCardsPageWorks.vue?vue&type=script&lang=js"
export * from "./WorkCardsPageWorks.vue?vue&type=script&lang=js"

import "./WorkCardsPageWorks.vue?vue&type=style&index=0&id=41798905&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41798905"]])

export default __exports__